import { inject, Injectable } from '@angular/core';
import {
  GetRowsRequest,
  RestApiService,
} from '@core/services/rest-api.service';
import {
  DvDropdownClientSideElement,
  DvDynamicFormElement,
} from '@devinco/ui/legacy';
import { ColumnType } from '@features/vt-grid/grid-options/column-types';
import { TranslateService } from '@ngx-translate/core';
import { TripDto } from '@pages/trips-page/components/trips-grid/interfaces';
import { activeRecordFilter } from '@shared/constants/active-record-filter';
import { Entity } from '@shared/constants/entity';
import { WeekDays } from '@shared/constants/weekdays';
import { ColDef, ValueGetterParams } from 'ag-grid-community';

@Injectable({ providedIn: 'root' })
export class TripImportGridService {
  private translate = inject(TranslateService);
  private api = inject(RestApiService);

  getColDefs = (): ColDef<TripDto>[] => [
    { field: 'TripID', type: ColumnType.Id, hide: true, sortable: false },
    {
      field: 'TrackerObjectDescription',
      type: ColumnType.Text,
      headerName: 'Grid.Vehicle',
      sortable: false,
      width: 170,
    },
    {
      headerName: 'Grid.Weekday',
      field: 'Weekday',
      type: [ColumnType.TranslatedText],
      valueGetter: (params: ValueGetterParams<TripDto>) => {
        return params.data?.Weekday;
      },
      filterParams: {
        maxNumConditions: 5,
        values: [...Object.keys(WeekDays)],
        valueFormatter: (data: { value: WeekDays | undefined }) => {
          return data.value
            ? this.translate.instant(`General.DaysOfWeek.${data.value}`)
            : '';
        },
      },
      valueFormatter: (data: { value: WeekDays | undefined }) => {
        return data.value
          ? this.translate.instant(`General.DaysOfWeek.${data.value}`)
          : '';
      },
      filter: 'agSetColumnFilter',
      sortable: true,
      width: 100,
    },
    {
      headerName: 'Grid.StartTime',
      field: 'StartTime',
      type: [ColumnType.DateTime],
      filterParams: {
        maxNumConditions: 5,
      },
      sort: 'desc',
      sortable: false,
    },
    {
      headerName: 'Grid.EndTime',
      field: 'EndTime',
      type: [ColumnType.DateTime],
      filterParams: {
        maxNumConditions: 5,
      },
      sortable: false,
    },
    {
      headerName: 'Grid.Distance',
      field: 'Distance',
      type: [ColumnType.Km],
      filterParams: {
        maxNumConditions: 5,
      },
      sortable: false,
    },
    {
      headerName: 'Grid.TripPoints',
      field: 'TripPoints',
      type: ColumnType.Text,
      hide: true,
    },
    {
      field: 'TrackerObjectID',
      type: ColumnType.Number,
      hide: true,
    },
    {
      field: 'TrackerID',
      type: ColumnType.Number,
      hide: true,
    },
  ];

  getPanelFormElements = (): DvDynamicFormElement[] => [
    new DvDropdownClientSideElement({
      key: 'TrackerObjectID',
      labelKeys: ['VehicleDescription'],
      valueKey: 'VehicleID',
      ready: params => {
        const request: GetRowsRequest = {
          entity: Entity.Vehicle,
          fields: ['VehicleID', 'VehicleDescription'],
          filterModel: activeRecordFilter,
        };
        this.api.setDropdownData(request, params, undefined);
      },
    }),
  ];
}
